import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
const TermsandConditions = () => {
  return <h4>TermsandConditions</h4>
}

const Wrapper = styled.main`
  background: var(--clr-primary-10);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  h1 {
    font-size: 10rem;
  }
  h3 {
    text-transform: none;
    margin-bottom: 2rem;
  }
`

export default TermsandConditions
